import { Injectable, inject } from '@angular/core';
import { AppSettingsService } from '../config/app-settings.service';

@Injectable({ providedIn: 'root' })
export class StudyCodeHelperService {
  private readonly appSettingsService = inject(AppSettingsService);


  isValidStudyCode(packageFolderName: string): boolean {
    const patterns = this.appSettingsService.studyCodePatterns;
    if (!patterns || patterns.length === 0) {
      return false;
    }
    return patterns.some(p => new RegExp(p, 'i').test(packageFolderName));
  }
}
